module.exports = __webpack_public_path__ + "f6cde2c45cab1a458d886e2bdb4000f6.jpg";